export default "__VITE_ASSET__D0qwMnwB__"